// Imports Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef, MatDialog } from '@angular/material';

// Imports Aplicacion
import { DError, DContextoMuiscaServicio, DLogger, DContextoMuisca } from '@dian/core';
import { DRutServicios, DTipoContribuyente } from '@dian/api-rut';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DDocumento, DDocumentoAtributos, DFirmaElectronica, DListaDocumentos, DInfoResumenFormulario, DAniosFormato, DPeriodicidadFormato, DPeriodoFormato, DVersionRutaFormato } from '@dian/api-formulario';
import { DSimple260IngresoServicios, DAnularFormulario, DFechaInscripcionRUT  } from '@dian-api/simple260-ingreso';
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490-260';
import { DReciboPagoDialogoServicio260 } from '@dian-cmp/recibo-pago-260';
import { DOperacionesGeneralesServicio, DMensajes, DUtilidadesFormularioServicio, DOperacionesGeneralesIngresoServicio } from '@dian-cmp/formulario';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { DReciboPagoDialogoServicio260Mun } from '@dian-cmp/recibo-pago-260-municipios';
import { DBasicosParametricasServicios, DParametrosPolitica } from '@dian/api-basicos-parametricas';

@Component({
    moduleId: module.id,
    selector: 'ingreso',
    templateUrl: 'ingreso.component.html',
    styleUrls: ['ingreso.component.css'],
    providers: [
        DNotificacionServicio,
        DSimple260IngresoServicios,
        DRutServicios,
        DUtilidadesFormularioServicio,
        //DReciboPagoDialogoServicio260,
        DReciboPagoDialogoServicio260Mun,
        DBasicosParametricasServicios
    ]
})
export class IngresoComponent implements OnInit {
      
    public mostrarOtros: boolean = false;
    private anioSeleccionadoPresentados:number;
    private arrDocumentosDiligenciamiento:DListaDocumentos;
    private arrDocumentosPresentados:DListaDocumentos;
    private arrDocumentosDefinitivos:DListaDocumentos;
    private constribuyenteId:string;
    private configuracionFormulario:DFormularioConfiguracion;
    private esFirmanteElectronico: DFirmaElectronica;
    private enProceso:boolean = true;
    private estadosCarga = {
        pendientes: false,
        presentados: false,
        definitivos: false,
        anios: false
    };
    private habilitarFraccionAnio:boolean = false; // CAMBIE A TRUE SI EL FORMULARIO REQUIERE EL USO DE FRACCIÓN DE AÑO
    private aniosFraccion = [];       // PONGA EL AÑO DE LA FRACCIÓN PARA LA VERSIÓN DEL FORMATO
    private hayFraccion:boolean = false;
    private hayInicial:boolean = false;
    private fraccionAnio:boolean = false;
    private firmaRequerida:boolean = false;
    private operacionesGenerales:DOperacionesGeneralesIngresoServicio; 
    private mostrarNuevoBorrador:boolean = true;
    private mostrarNuevoBorradorFraccion:boolean = false;   
    private mostrarDocumentosEnProceso:boolean = true;
    private mostrarDocumentosEnBorrador:boolean = true;
    private mostrarDocumentosEnDefinitivo:boolean = true;
    private periodicidadDeshabilitada:boolean = true;    
    private aniosFormato:DAniosFormato;
    private anioSeleccionado:number;
    private anioSeleccionadoFraccion:number;
    private periodicidadFormato:DPeriodicidadFormato;
    private periodicidadSelecionada:string;   
    private periodosFormato:DPeriodoFormato;
    private periodoSeleccionado = null;  
    private tipoContribuyente: DTipoContribuyente;   
    private existenBorradoresDefinitivosInicial: boolean = false;
    private existenBorradoresDefinitivosFraccion: boolean = false; 
    private datosContexto:DContextoMuisca;
    private versionesRuta: Array<DVersionRutaFormato>;
    public disableBtnPagoCuotas:boolean = true;
    public existenDocsPresentadosAnio:boolean = false;
    public fechaInscripcionRUT: number;
    private aplicaArt93:boolean = false;
    private aplicaArt93Vigente:boolean = false;

    /**
     * @constructs ConfiguracionSelectorComponent
     */
    constructor(
        private router: Router,
        private dialog:MatDialog,
        public dNotificacionServicio: DNotificacionServicio,
        private dServicioRESTAPI: DSimple260IngresoServicios,
        private dRutServicios: DRutServicios,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private logger: DLogger,
        private dutilidades: DUtilidadesFormularioServicio,
        //private dReciboPagoServicio: DReciboPagoDialogoServicio260,
        private dReciboPagoServicio: DReciboPagoDialogoServicio260Mun,
        private dBasicosParametricasServicios:DBasicosParametricasServicios
    ) { 
        this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(this.dNotificacionServicio, this.dServicioRESTAPI, this.dialog); 
        this.configuracionFormulario = new DFormularioConfiguracion();
        this.arrDocumentosDiligenciamiento = new DListaDocumentos();  
        this.arrDocumentosPresentados = new DListaDocumentos();
        this.arrDocumentosDefinitivos = new DListaDocumentos();
        this.aniosFormato = new DAniosFormato();
        this.periodicidadFormato = new DPeriodicidadFormato();
        this.periodosFormato = new DPeriodoFormato();
        this.tipoContribuyente = new DTipoContribuyente();
        this.esFirmanteElectronico = new DFirmaElectronica();        
        this.datosContexto = new DContextoMuisca();
        this.versionesRuta = new Array<DVersionRutaFormato>();
    }

    /**
    * Interface for on init document.
    * @interface
    */
    ngOnInit() { 
        setTimeout(() => {  
            this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta                     
        }, 50);        
        this.mostrarNuevoBorrador=true;
    }

    /**
    * @desc Funcion para conocer si el contribuyente tiene firma electronica
    * @param {String} ideDocumento
    */
    public consultarFirmanteElectronico(ideDocumento:string) {
        let observableServicio = this.operacionesGenerales.consultarFirmanteElectronico(ideDocumento);
        observableServicio.subscribe(
            res => {
                this.esFirmanteElectronico = <DFirmaElectronica>res;
                this.firmaRequerida = this.esFirmanteElectronico.esFirmaElectronica;
                
                ///////////////borrar
                //if(!this.firmaRequerida)this.firmaRequerida=true;
                //////////////////////////////

                if (this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO && !this.firmaRequerida) {                       
                    let dialogFirma = this.dNotificacionServicio.mostrarDialogoError(DMensajes.SIN_FIRMA_ELECTRONICA);
                    dialogFirma.afterClosed().subscribe(result => {
                        this.operacionesGenerales.irPaginaDashboard(); 
                    });                        
                } else {
                    this.enProceso = true;
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let definitivos = this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO;
                    this.obtenerDocs(definitivos ? false : true); 
                    this.obtenerIdentidad();  
                    this.obtenerAnios();  
                    this.obtenerFechaInscripcionRUT();
                    this.validarCargaCompletaFormulario(precarga);
                    this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);
                    this.confirmarValAplicaArt93();
                }                    
            }
        );            
    } 

    /**
    * @desc Funcion para validar si el formulario esta completamente cargado y remover la animacion de precarga
    * @ignore
    */
    private validarCargaCompletaFormulario(precarga) {
        let intervalId = setInterval(()=>{
            let bandera = true;
            let atributos = Object.keys(this.estadosCarga);

            for(let i in atributos){
                if(!this.estadosCarga[atributos[i]]){
                    bandera = false;
                    break;
                }
            }

            if(bandera){
                this.enProceso = true;
                precarga.close();
                clearInterval(intervalId);  
            }                        
        }, 500);
    }

    /**
    * @desc Funcion para obtener los aÃ±os
    */
    private obtenerAnios() {
        let observableServicio = this.dServicioRESTAPI.consultarAniosFormato();
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Años ", res);
                this.aniosFormato = <DAniosFormato>res;               
                let anios:Array<number>=[];
                this.aniosFormato.anios.forEach((anio) =>{
                    if(Number(anio)>2018){
                        anios.push(anio);
                    }else{
                        this.mostrarOtros = true;
                    }
                });
                this.aniosFormato.anios=anios;
                if (this.aniosFormato.anios.length === 1) {
                    this.anioSeleccionado = this.aniosFormato.anios[0];
                    this.obtenerPeriodicidad(this.anioSeleccionado);
                }                


                this.estadosCarga.anios = true;             
            },
            error => {
                this.estadosCarga.anios = true;
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de aÃ±os.");
            }
        );
    }
    
    public redireccionarSelectorFlex() {
           window.location.href = `${window.location.origin}/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=${this.configuracionFormulario.NUMERO_FORMULARIO}`
    }

    /**        
    * @desc Funcion para construir el listado de los años para fraccion de año      
    */      
    private obtenerAniosFraccion() {      
        let anioActual = (new Date()).getFullYear();        
        this.aniosFraccion.push(anioActual);        
    }

    /**
    * @desc Funcion para verificar si el formulario debe de mostrar la seccion de fraccion de año
    * @param {Number} anio
    */
    private verificarFraccionAnio(anio:number) {
        const anioActual = (new Date()).getFullYear();
        this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;    
      //  if(Number(anio)===2024)this.fraccionAnio =true;

    }

    /**
    * @desc Funcion para obtener la periodicidad
    */
    private obtenerPeriodicidad(anio:number) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodicidad(anio);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Periodicidad ", res);
                this.periodicidadFormato = <DPeriodicidadFormato>res;
                if (this.periodicidadFormato.listaPeriodicidades.length === 1) {
                    this.periodicidadSelecionada = this.periodicidadFormato.listaPeriodicidades[0].nombre;
                    this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
                }
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodicidades.");
            }
        );
    }

    /**
    * @desc Funcion para obtener los periodos
    */
    private obtenerPeriodos(anio:number, periodicidad:string) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodos(anio, periodicidad);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Periodos ", res);
                this.periodosFormato = <DPeriodoFormato>res;
                if (this.periodosFormato.listaPeriodos.length === 1) {
                    this.periodoSeleccionado = this.periodosFormato.listaPeriodos[0];
                    this.validarActivarBotonPagoCuotas();
                }
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodos."); 
            }
        );
    }    

    /**
    * @desc Funcion para obtener los documentos pendientes y presentados
    * @param {boolean} definitivos
    */
    public obtenerDocs(definitivos?: boolean) {        
        this.obtenerDocsPendientes();
        this.obtenerDocsPresentados();
        if( definitivos) {
            this.obtenerDocsDefinitivos();
        } else {
            this.estadosCarga.definitivos = true;
        }     
    }

    /**
    * @desc Funcion para obtener los documentos pendientes
    */
    public obtenerDocsPendientes() {
        let observableDiligenciamiento = this.dServicioRESTAPI.consultarFormulariosEstado('pendiente'); 
        observableDiligenciamiento.subscribe(
            res => {
                this.hayFraccion = false;
                this.logger.info("Obteniendo Documentos Pendientes ", res);                
                this.arrDocumentosDiligenciamiento = <DListaDocumentos>res;             
                this.arrDocumentosDiligenciamiento.infoFormularios.forEach((item, index) => {
                    if (item.modo === 'fraccion' || item.modo === 'fraccion_correccion'){
                        this.hayFraccion = true;
                    }
                    if (item.modo === 'inicial' || item.modo === 'correccion') {
                        this.hayInicial = true;                        
                    }
                });
                this.estadosCarga.pendientes = true;
            },
            error => {
                this.estadosCarga.pendientes = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los documentos presentados
    */
    public obtenerDocsPresentados(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('presentado');
        observablePresentados.subscribe(
            res => {
                this.logger.info("Obteniendo Documentos Presentados ", res);
                let eliminoAntes = false;
                let arrPresentados = <DListaDocumentos>res;                
                for(let i=0;i<arrPresentados.infoFormularios.length;i++) {
                    if (eliminoAntes) i = i - 1;
                    let item = arrPresentados.infoFormularios[i];
                    if (item.modo === 'ineficaz') {
                        if (item.infoCorreccion.esCorreccion) {
                            this.habilitarCorreccionFormulario(arrPresentados, item.infoCorreccion.ideDocumentoCorrige);
                        }
                        arrPresentados.infoFormularios.splice(i, 1);
                        eliminoAntes = true;
                    } else {
                        eliminoAntes = false;
                    }
                }

                this.arrDocumentosPresentados = arrPresentados;
                this.estadosCarga.presentados = true;                
            },
            error => {
                this.estadosCarga.presentados = true;
            }
        );      
    }


    //Si existe un documento ineficaz se llama esta funcion para habilitar la correcion del documento anterior
    private habilitarCorreccionFormulario(lista: DListaDocumentos, idDocumento: string) {
        for (let i in lista.infoFormularios) {
            if (String(lista.infoFormularios[i].identificador.id) === idDocumento) {
                lista.infoFormularios[i].atributos.docAtributos.puedeSerCorregido = true;
                break;
            }
        }
    }


    /**
    * @desc Funcion para obtener los documentos definitivos
    */
    public obtenerDocsDefinitivos(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('definitivo');
        observablePresentados.subscribe(
            res => {
                this.logger.info("Obteniendo Documentos Definitivos ", res);
                this.arrDocumentosDefinitivos = <DListaDocumentos>res;
                let ArrayLength = this.arrDocumentosDefinitivos.infoFormularios.length;     
                for(let i=0;i<ArrayLength;i++){     
                    if(this.arrDocumentosDefinitivos.infoFormularios[i].modo == "fraccion"){        
                        this.existenBorradoresDefinitivosFraccion = true;       
                    }       
                    if(this.arrDocumentosDefinitivos.infoFormularios[i].modo == "inicial"){     
                        this.existenBorradoresDefinitivosInicial = true;        
                    }       
                }               
                this.estadosCarga.definitivos = true;                
            },
            error => {
                this.estadosCarga.definitivos = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los datos de identidad
    */
    private obtenerIdentidad(){
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();     
        observableServicio.subscribe(
            res => {
                this.datosContexto = <DContextoMuisca>res;
                let datosRespuesta:DContextoMuisca = <DContextoMuisca>res;
                this.consultarTipoContribuyente(datosRespuesta.ANombrePropio ? datosRespuesta.NitUsuario : datosRespuesta.NitOrganizacion);                            
            },                     
            error =>{  
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_CON_IDENTIDAD);                      
            }
        );    
    }

    
    /**
    * @desc Funcion para crear un nuevo borrador
    * @param {String} concepto
    */
    public validarCrearNuevoBorrador(concepto: String) {
        if(this.anioSeleccionado == 2023){
            this.dNotificacionServicio.mostrarDialogoInformacionBloqueante(`
                Los contribuyentes que obtuvieron ingresos por las actividades del grupo 3 (sic) “Servicios profesionales de consultoría y científicos en los que predomine el factor intelectual sobre el material, incluidos los servicios de profesiones liberales”, en aplicación de la Sentencia C-540/23 el Servicio Informático calculará el impuesto SIMPLE con las tarifas del numeral 3 del artículo 908 del E.T. modificado por el artículo 42 de la Ley 2155 de 2021.
                <br/>
                Si obtuvo ingresos iguales o superiores a 12.000 UVT por las actividades del grupo 3 (sic) “Servicios profesionales de consultoría y científicos en los que predomine el factor intelectual sobre el material, incluidos los servicios de profesiones liberales” y no pudo inscribirse o permanecer como contribuyentes del SIMPLE con motivo de las normas que declaró inexequibles la Sentencia C-540/23 o es persona natural y sus ingresos no superan las 3.500 UVT, ingrese a la Sección de “Ajustes a Bimestres Recibo Electrónico SIMPLE” y registre en uno o varios bimestres los valores para liquidar los impuestos que conforman la declaración anual consolidada.
                `).afterClosed()
            .subscribe(
              res => {
                this.crearNuevoBorrador(concepto);
            });
        }else{
            this.crearNuevoBorrador(concepto);
        }
    }

    /**
    * @desc Funcion para crear un nuevo borrador
    * @param {String} concepto
    */
    public crearNuevoBorrador(concepto: String) {
        // mensual, bimestral, cuatrimestral, anual, aperiodico
        let queryStringParams;
        if (concepto === 'inicial') {
            if(this.existenBorradoresDefinitivosInicial){
                this.copiarFormulario(this.arrDocumentosDefinitivos.infoFormularios[0],true);
            }
            else{            
                queryStringParams = {
                    concepto: concepto, 
                    anio: this.anioSeleccionado, 
                    periodicidad: this.periodicidadSelecionada, 
                    periodo: this.periodoSeleccionado.id ? this.periodoSeleccionado.id : "null"
                };
            }
        } else {
            if(this.existenBorradoresDefinitivosFraccion){
                this.copiarFormulario(this.arrDocumentosDefinitivos.infoFormularios[0],true);
            }
            else{            
                queryStringParams = {
                    anio: this.anioSeleccionadoFraccion,
                    concepto: concepto,
                    periodicidad: "anual", 
                    periodo: "1"              
                };
            }
        }
        
        let params = this.dutilidades.getQueryStringParams(queryStringParams);   
        //window.location.href = location.origin + '/formulario?' + params; 
        //this.router.navigate(['/formulario'], { queryParams: queryStringParams });
        this.enProceso = true;        
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let indModoFraccion = concepto == "fraccion" ? "S" : "N" ;
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(queryStringParams.anio, queryStringParams.periodicidad, queryStringParams.periodo, indModoFraccion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();                
                this.enProceso = false;  
                this.logger.info("URL Crear nuevo borrador: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                
                this.redirigirFormulario(version,params);
               
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        );        
    }

    /**
    * @desc Funcion para consultar el tipo de contribuyente
    * @param {string} nit del contribuyente
    */
    public consultarTipoContribuyente(nit: string) {
        let observableServicio = this.dRutServicios.consultarTipoContribuyente(nit);
        observableServicio.subscribe(
            res => {
                this.tipoContribuyente = <DTipoContribuyente>res;
                this.constribuyenteId = this.tipoContribuyente.id;           
            },
            error => {
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_OBTENIENDO_CONTRIBUYENTE);                
            }
        );
    } 

    /**
    * @desc Funcion para imprimir el formulario
    */
    public imprimirFormulario(idFormulario:string) {
        this.operacionesGenerales.imprimirFormulario(idFormulario);      
    }  

    
    private confirmarValAplicaArt93() {
        this.dBasicosParametricasServicios.obtenerPolitica(354,"VIGENCIA_ART93").subscribe(
            res=>{
                let parametroPolitica = <DParametrosPolitica>res;
                let vigenciaArt93 = parametroPolitica.parametros[0].valor; 
                let fechaDesde = Number(vigenciaArt93.split('-')[0]);
                let fechaHasta = Number(vigenciaArt93.split('-')[1]);
                let d = new Date();
                let hoy = Number(d.getFullYear() + "" + ("0"+(d.getMonth()+1)).slice(-2) + "" + ("0" + d.getDate()).slice(-2));                
                if(hoy<fechaDesde || hoy>fechaHasta){
                    this.aplicaArt93Vigente = false;//la fecha de hoy no se encuentra en la vigencia
                    this.aplicaArt93 = false;//Se asigna valor por defecto false a la respuesta SI/NO
                }else{
                    this.aplicaArt93Vigente = true;//la fecha de hoy SI se encuentra en la vigencia
                }
            },error=>{
                //this.dNotificacionServicio.mostrarDialogoInformacion("Error obteniendo política de vigencia artículo 93");
                console.log('Error obteniendo política de vigencia artículo 93. ' + error);
            }
        );
    }


    /**
    * @desc Funcion para pagar el formulario
    * @param {String} idFormulario
    * @param {String} anioGravable
    * @param {String} periodo
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public pagarFormulario(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario:DInfoResumenFormulario) {
        let esCorreccion:boolean = objetoFormulario.infoCorreccion.esCorreccion;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {

            //Verificar vigencia para realizar la pregunta de aplicaArt93
            if(this.aplicaArt93Vigente && (anioGravable=="2019" || anioGravable=="2020" || anioGravable=="2021" || (anioGravable=="2022" && esCorreccion))){//Pregunta Art93 es vigente, se pregunta SI/NO
                let arrayButtonsArt93 =[
                    {text: 'Si', value:1, mdClass: 'primary', disabled:false},
                    {text: 'No', value:0, mdClass: 'primary', disabled:false}
                ];
                let contenidoArt93:string = `<p>Señor contribuyente:</p>
                    <p>¿Considera que cumple las condiciones establecidas en el Artículo 93 de la Ley 2277 del 2022 y desea aplicar la tasa de interés reducida de la citada norma?</p>
                    <p>Recuerde que la tasa reducida del Artículo 93 no es aplicable para el pago de Anticipos Bimestrales, en consecuencia, no se aplicará a los intereses generados sobre los “Ajustes Mayores Anticipos” en el formulario 260.</p>
                    <p>Seleccione una respuesta:</p>
                `;
                let notificacion= this.dNotificacionServicio.mostrarDialogoPersonalizado("Preguntas",contenidoArt93, "", arrayButtonsArt93, "", "", false);
                notificacion.afterClosed().subscribe(
                    result =>{
                        if (result == 1){//Responde si
                            this.aplicaArt93 = true;
                        }else{
                            this.aplicaArt93 = false;
                        }
                        this.generarLiquidacionReciboPago(idFormulario,esCorreccion,precargaProceso);
                    });
            }else{//Pregunta Art93 NO es vigente, se envía respuesta en NO(false)
                this.generarLiquidacionReciboPago(idFormulario,esCorreccion,precargaProceso);
            }
            
        } else {
            precargaProceso.close();
            let modelo = new DDocumento();
            modelo.doc.cab.cs_id_4 = idFormulario;
            modelo.doc.cab.cs_id_1 = anioGravable;
            modelo.doc.cab.cs_id_3 = periodo ? periodo : "1"; 
            let contribuyente = this.tipoContribuyente.granContribuyente ? '3' : this.constribuyenteId;
            let atributos = objetoFormulario.atributos.docAtributos;
            let tipoDoc = atributos.esDefinitivo ? '2' : atributos.esPresentado ? '5' : null;
            this.operacionesGenerales.pagarFormulario(modelo, contribuyente, this.configuracionFormulario.NUMERO_FORMULARIO, tipoDoc);
        }   
    }

    private generarLiquidacionReciboPago(idFormulario:string,esCorreccion:boolean,precargaProceso){
        let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario,'',this.aplicaArt93);
        observableServicio.subscribe(
            res => {
                precargaProceso.close();
                let liquidacion = <DLiquidacionRecibo>res;
                if (liquidacion) this.dReciboPagoServicio.mostrarDialogoReciboPago(
                    this.datosContexto,
                    this.firmaRequerida, 
                    liquidacion,
                    null,
                    null,
                    true,
                    esCorreccion
                );
            },
            error => {
                precargaProceso.close();
                this.dNotificacionServicio.mostrarDialogoInformacion("No existen valores monetarios a pagar.");
                console.log('Servicio generar liquidacion del recigo de pago ejecutado con error');
            }
        );   
    }


    /**
    * @desc Funcion para realizar el pago de primera cuota del formulario (descomentar si el formulario lo requiere)
    */
    /*public crearPagoPrimeraCuota() {
        this.enProcesoPago = true;
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.iniciarPrimerPago(this.anioSeleccionado);
        observableServicio.subscribe(
            res => {
                if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {
                    let liquidacion = <DLiquidacionRecibo>res;
                    if (liquidacion) this.dReciboPagoServicio.mostrarDialogoReciboPago(liquidacion);
                }
                precarga.close();
                this.enProcesoPago = false;
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error Generando el recibo de pago.");
                this.enProcesoPago = false;
            }
        );
        precarga.close();
    }*/ 


    /**
    * @desc Funcion para editar el formulario
    * @param {Object} objetoFormulario
    */
    public editarFormulario(objetoFormulario:DInfoResumenFormulario){
        let esCorreccion:boolean = objetoFormulario.infoCorreccion.esCorreccion;
        let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;
        let queryStringParams = null;
        if(esCorreccion) {
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: periodo,
                documento: objetoFormulario.infoCorreccion.ideDocumentoCorrige
            };            
        } else {           
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: periodo,
                idedocumento: objetoFormulario.identificador.id
            };
        }
        let anioVersion = Number(objetoFormulario.anio);
        if(objetoFormulario.modo == "fraccion_correccion")
        {
            anioVersion=anioVersion+1;
            queryStringParams.anio=queryStringParams.anio+1;
        }
        let params = this.dutilidades.getQueryStringParams(queryStringParams);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();      
        let periodoVersion = Number(periodo);
        let indModoFraccion = objetoFormulario.modo == "fraccion" || objetoFormulario.modo == "fraccion_correccion" ? "S" : "N";
        
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion, indModoFraccion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;  
                precargaProceso.close();
                this.enProceso = false;
                this.logger.info("URL Editar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                  
                this.redirigirFormulario(version,params);
                                  
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;            
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        ); 
    }

    /**
    * @desc Funcion para consultar los formularios por aÃ±o gravable
    * @param {Number} anio
    */
    public consultarFormulariosPorAnio(anio:number){
        this.enProceso = true;
        this.anioSeleccionadoPresentados = anio;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarFormulariosEstado('presentado', anio); 
        observableServicio.subscribe(
            res => {
                this.arrDocumentosPresentados = <DListaDocumentos>res;
                precargaProceso.close();
                this.enProceso = false;
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
            }
        ); 

    }

    /**
    * @desc Funcion para corregir un formulario presentado
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public corregirFormulario(objetoFormulario:DInfoResumenFormulario){  
        let esCorreccion = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        esCorreccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": esCorreccion;
        let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;

        let queryStringParams = {
            concepto: esCorreccion,
            anio: objetoFormulario.anio, 
            periodicidad: objetoFormulario.periodicidad, 
            periodo: periodo ? periodo : "null",
            documento: objetoFormulario.identificador.id
        };
        if(esCorreccion==="fraccion_correccion")
        {
            queryStringParams.anio=objetoFormulario.anio+1;
        }
        let params = this.dutilidades.getQueryStringParams(queryStringParams);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(periodo);       
        let indModoFraccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "S" : "N";

       
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion, indModoFraccion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;    
                this.logger.info("URL Corregir formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);
                     
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        ); 
    }

    /**
    * @desc Funcion para copiar los formularios cuando son definitivos
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public copiarFormulario(objetoFormulario: DInfoResumenFormulario, newForm:boolean=false) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let modo = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        //modo = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": modo;
        let anio = Number(objetoFormulario.anio);
        let periodicidad = objetoFormulario.periodicidad;
        let periodo = objetoFormulario.periodicidad === 'anual' || !objetoFormulario.periodo ? 1 : objetoFormulario.periodo;
        let queryStringParams = {
                idedocumento: ideDocumento,
                concepto: modo, 
                anio: anio, 
                periodicidad: periodicidad, 
                periodo: periodo,
                clonar: true,
                nuevoForm: newForm
            }; 

        let params = this.dutilidades.getQueryStringParams(queryStringParams);   
        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;  
                this.logger.info("URL Copiar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);                
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        );      
    } 

    public confirmarAnulacion(objetoFormulario: DInfoResumenFormulario){
        let confirmacion = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: Al oprimir “Confirmar” se procede con la anulación del borrador de esta declaración y debe realizar un nuevo diligenciamiento");

        confirmacion.afterClosed().subscribe(
            res=>{
                if(res){
                    this.anularFormulario(objetoFormulario);
                }                
            }
        );
    }

    public anularFormulario(objetoFormulario: DInfoResumenFormulario) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let observableVersionFormato = this.dServicioRESTAPI.anularFormulario(ideDocumento);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionFormato.subscribe(
            res => { 
                precargaProceso.close();
                this.enProceso = false;  
                this.dNotificacionServicio.mostrarDialogoInformacion("Se ha anulado el documento: "+objetoFormulario.identificador.id);
                this.arrDocumentosDiligenciamiento =  new DListaDocumentos();
                this.obtenerDocs();   
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("No fue posible eliminar el documento: "+objetoFormulario.identificador.id);
            }
        );           
    }

    /**
    * @desc Funcion para obtener todas las versiones del formulario que esten en Angular
    * @param {Number} ideFormato
    */
    public obtenerVersionesRuta(ideFormato:number){
        let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionesFormato.subscribe(
            res => { 
                this.versionesRuta = <Array<DVersionRutaFormato>>res;
                let anio = 0;
                for(let version of this.versionesRuta){
                    if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año
                        this.habilitarFraccionAnio = true;//Si hay fracción se activa el toolbar de fracción                        
                        if (anio < version.anioGravable) anio = version.anioGravable; 
                        this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
                    }
                }
                this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
                this.mostrarNuevoBorradorFraccion = this.habilitarFraccionAnio ? true : false;
                precargaProceso.close();
                this.enProceso = false;  
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
            }
        );          
    }       
    
    public validarActivarBotonPagoCuotas(){
        let periodicidad = this.periodicidadFormato.listaPeriodicidades.find(period=> period.nombre == this.periodicidadSelecionada);
        let idePeriodicidad;
        if(periodicidad.id == 1){//pendiente consultar este dominio y cruzar contra valores
            idePeriodicidad = 19110708;
        }else if(periodicidad.id == 4){
            idePeriodicidad = 19110706;
        }else if(periodicidad.id == 3){
            idePeriodicidad = 19110712;
        }else if(periodicidad.id == 6){
            idePeriodicidad = 19110705;
        }else if(periodicidad.id == 12){
            idePeriodicidad = 19110704;
        }
        let version = this.versionesRuta.find(ver=> ver.anioGravable == this.anioSeleccionado && ver.idPeriodicidad == idePeriodicidad && this.periodoSeleccionado.id <= ver.idPeriodo && ver.indModoFraccion == "N");        
        if(version && version.indPagoCuota == "S"){
            this.disableBtnPagoCuotas = false;
        }else{
            this.disableBtnPagoCuotas = true;
        }       
    }

    public redirigirFormulario(version:DVersionRutaFormato, params:string){
        if(version.indAccesoFormulario == "N"){
            this.dNotificacionServicio.mostrarDialogoError("El formulario solicitado no esta disponible para su diligenciamiento.");
        }else{
            window.location.href = location.origin + version.urlFormato + 'v' + version.version + '?' + params;
        } 
    }    

    public validarPuedePagarCuota(anioSeleccionado){
        let docPresentadoAnio = this.arrDocumentosPresentados.infoFormularios.find( doc => doc.anio == anioSeleccionado);
        if(docPresentadoAnio){
            this.existenDocsPresentadosAnio = true;
        }
    }


    
    public validarPuedePresentarFraccion(){
        let anioFraccion = Number(this.anioSeleccionadoFraccion) - 1;
        let documento = this.arrDocumentosPresentados.infoFormularios.find(doc => doc.anio == anioFraccion);
        if(documento){
            let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion(`Señor Contribuyente: RECUERDE que la Declaración de Fracción año gravable siguiente, es la última Declaración que se presenta ante la DIAN; por la terminación del trámite de liquidación de su empresa o porque terminó el trámite de liquidación de la sucesión del contribuyente<br><br>Además, debe tener en cuenta que el diligenciamiento del formulario 260 fracción de año exige que se presenten previamente los recibos electrónicos bimestrales del año gravable ${this.anioSeleccionadoFraccion}. En caso de que la liquidación de la sociedad o la sucesión se hubiese realizado en un bimestre anterior del presente año, los demás bimestres se presentan en cero.`);
            dialogFirma.afterClosed().subscribe(result => {
                if(result) this.crearNuevoBorrador('fraccion');                 
            }); 
               
        }else{
            let anioInscripcion = Number(String(this.fechaInscripcionRUT).substr(0,4));
            if(anioInscripcion >= Number(this.anioSeleccionadoFraccion)){ //si el año de inscripción en el rut es 2021 permite
                let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: RECUERDE que la Declaración de Fracción año gravable siguiente, es la última Declaración que se presenta ante la DIAN; por la terminación del trámite de liquidación de su empresa o porque término el trámite de liquidación de la sucesión del contribuyente");
                dialogFirma.afterClosed().subscribe(result => {
                    if(result) this.crearNuevoBorrador('fraccion');                 
                }); 
            }else{
                let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion(`Señor Contribuyente: Verifique si, para presentar la Declaración Fracción año gravable ${this.anioSeleccionadoFraccion}, debe haber presentado la Declaración correspondiente al año gravable ${anioFraccion}.`);
                dialogFirma.afterClosed().subscribe(result => {
                    if(result) this.crearNuevoBorrador('fraccion');                 
                }); 
            }        
        }      
    }

    
    public obtenerFechaInscripcionRUT(){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        this.dServicioRESTAPI.obtenerFechaInscripcionRUT().subscribe(
            res=>{
                precargaProceso.close();
                let respuesta = <DFechaInscripcionRUT>res;
                this.fechaInscripcionRUT = respuesta.fechaInscripcionRUT;
            },error=>{
                precargaProceso.close();
                this.dNotificacionServicio.mostrarDialogoError("No es posible consultar la fecha de inscripción en el RUT.", error);
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/src/app/components/ingreso/ingreso.component.ts